import { useParams } from "react-router-dom";

import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import FormHeaderComponent from "../component/FormHeaderComponent";
import { constants } from "../constant/constants";
import { useState, useEffect } from "react";
import RestaurantEditComponent from "../component/restaurants/RestaurantEditComponent";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";

export default function RestaurantEdit() {
  const params = useParams();
  const { user } = useUserStore();
  const [restaurant, setRestaurant] = useState({
    restaurantName: "",
    logo: "",
  });
  const [isRestaurantLoading, setIsRestaurantLoading] = useState(false);

  async function getRestaurantDetails(id) {
    if (id === null) return;
    const token = user.token.token;
    const { payload } = await ApiService.GET_RESTAURANT_WITH_ID(id, token);
    return payload;
  }

  useEffect(() => {
    if (params.restaurantId === "") return;
    getRestaurantDetails(params.restaurantId).then((data) => {
      setRestaurant({
        ...data,
        restaurantName: data.name,
        logo: data.logo,
      });
      setIsRestaurantLoading(true);
    });
  }, [params]);

  return (
    <section>
      <div class="flex flex-col bg-[#e5e7eb]">
        {/* {contextHolder} */}
        {/* <CustomLoader /> */}
        <Header title={""} menu={constants.SUPER_MENU.RESTAURANT} currentMenuKey={'T_51_S_51'}/>
        <div className="flex flex-row bg-prewhite">
          <SideMenu
            title={`McDonalds Food Chain`}
            menu={constants.SUPER_MENU.RESTAURANT}
          />
          <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[80px]">
            <div className="flex flex-col w-full">
              <FormHeaderComponent
                title={`Restaurant Edit`}
                listRoute={`/restaurants`}
              />
              <div className="">
                {isRestaurantLoading && (
                  <RestaurantEditComponent
                    records={{
                      data: restaurant,
                      restaurantId: params.restaurantId
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
